import { Injectable } from '@angular/core';
import { LocalstoreService } from 'src/app/core/services/localstore/localstore.service';
import { AALocationModel } from 'src/app/modules/route-planner/models/route-model';
import { Enums } from 'src/app/modules/route-planner/enums/route.enum';

@Injectable({
  providedIn: 'root'
})
export class RoutePlannerLocalStoreService {

  private localStoreName = 'ROUTE_PLANNER';
  private localStoreHistory: Array<{description: string}> = [];
  private readonly MAX_HISTORY_LIST: number = 15;

  constructor(private localStore: LocalstoreService) {
    // load first time
    this.localStoreHistory = this.getLocalStore();
  }

  public saveLocationIntoLocalStore(locationModelList: Array<AALocationModel>) {
    locationModelList.forEach( locationModel => {
      if (locationModel.isCurrentLocation() == false
        && (locationModel.RouteType == Enums.RouteType.FromDestination || locationModel.RouteType == Enums.RouteType.ToDestination) ) {
        this.saveLocalStore(locationModel);
      }
    });
  }

  // store & retrive localstore history
  private saveLocalStore(locationModel: AALocationModel) {
    const found = this.localStoreHistory.filter( item => {
      return (item.description == locationModel.Name);
    });

    if (found.length <= 0) {
      this.localStoreHistory.unshift( {description: locationModel.Name} );

      // restrict only 5 items in the history;
      this.localStoreHistory =  this.localStoreHistory.slice(0, this.MAX_HISTORY_LIST);

      const list = this.localStoreHistory.map( (item: any) => {
        return item.description;
      });

      this.localStore.saveData(this.localStoreName, list.join('|') );
    }

    return this.localStoreHistory;
  }

  public getLocalStore(): any {
    const list = this.localStore.retriveData(this.localStoreName);

    if (list) {
      this.localStoreHistory = list.split('|').map( (item) => {
        return {description: item};
      });
    }
    return this.localStoreHistory;
  }

}
